import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  { path: '/:pathMatch(.*).vue', redirect: to => to.path.split('.')[0] },
  { path: '/:pathMatch(.*)*', name: 'Error404', component: () => import('@/views/Error404.vue') },

  { path: '/'     , name: 'Home' , component: () => import('@/views/Home.vue' ) },
  { path: '/Admin', name: 'Admin', component: () => import('@/views/Admin.vue') },

  { meta: { choosable: 1, group: 'シーズン1' }, path: '/P01', name: '第1章', component: () => import('@/views/P01.vue') },
  { meta: { choosable: 1, group: 'シーズン1' }, path: '/P02', name: '第2章', component: () => import('@/views/P02.vue') },
  { meta: { choosable: 1, group: 'シーズン1' }, path: '/P03', name: '第3章', component: () => import('@/views/P03.vue') },

  { meta: { choosable: 1, group: 'シーズン1' }, path: '/P04'    , name: '第4章'                 , component: () => import('@/views/P04.vue'    ) },
  { meta: { choosable: 0, group: 'シーズン1' }, path: '/P04/C01', name: '第4章［コレクション1］', component: () => import('@/views/P04_C01.vue') },
  { meta: { choosable: 0, group: 'シーズン1' }, path: '/P04/C02', name: '第4章［コレクション2］', component: () => import('@/views/P04_C02.vue') },

  { meta: { choosable: 1, group: 'シーズン1' }, path: '/P05'    , name: '第5章'                 , component: () => import('@/views/P05.vue'    ) },
  { meta: { choosable: 0, group: 'シーズン1' }, path: '/P05/C01', name: '第5章［コレクション1］', component: () => import('@/views/P05_C01.vue') },
  { meta: { choosable: 0, group: 'シーズン1' }, path: '/P05/C02', name: '第5章［コレクション2］', component: () => import('@/views/P05_C02.vue') },

  { meta: { choosable: 1, group: 'シーズン1' }, path: '/P06'    , name: '第6章'                 , component: () => import('@/views/P06.vue'    ) },
  { meta: { choosable: 0, group: 'シーズン1' }, path: '/P06/C01', name: '第6章［コレクション1］', component: () => import('@/views/P06_C01.vue') },
  { meta: { choosable: 0, group: 'シーズン1' }, path: '/P06/C02', name: '第6章［コレクション2］', component: () => import('@/views/P06_C02.vue') },

  { meta: { choosable: 1, group: 'シーズン2' }, path: '/2P01', name: 'スタジオ第1章', component: () => import('@/views/2P01.vue') },
  { meta: { choosable: 1, group: 'シーズン2' }, path: '/2P02', name: 'スタジオ第2章', component: () => import('@/views/2P02.vue') },
  { meta: { choosable: 1, group: 'シーズン2' }, path: '/2P03', name: 'スタジオ第3章', component: () => import('@/views/2P03.vue') },
  { meta: { choosable: 1, group: 'シーズン2' }, path: '/2P04', name: 'スタジオ第4章', component: () => import('@/views/2P04.vue') },
  { meta: { choosable: 1, group: 'シーズン2' }, path: '/2P05', name: 'スタジオ第5章', component: () => import('@/views/2P05.vue') },
  { meta: { choosable: 1, group: 'シーズン2' }, path: '/2P06', name: 'スタジオ第6章', component: () => import('@/views/2P06.vue') },
  { meta: { choosable: 1, group: 'シーズン2' }, path: '/2P07', name: 'スタジオ第7章', component: () => import('@/views/2P07.vue') },
  { meta: { choosable: 1, group: 'シーズン2' }, path: '/2P08', name: 'スタジオ第8章', component: () => import('@/views/2P08.vue') },

  { meta: { choosable: 1, group: 'シーズン3' }, path: '/3P01', name: 'スタジオ第9章  (オルスタ第1章)', component: () => import('@/views/3P01.vue') },
  { meta: { choosable: 1, group: 'シーズン3' }, path: '/3P02', name: 'スタジオ第10章 (オルスタ第2章)', component: () => import('@/views/3P02.vue') },
]

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(_to, _from, savedPosition): any {
    return savedPosition || { left: 0, top: 0 }
  },
})

export default router
